import React, { memo, createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stepper as MuiStepper } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { capitalize } from 'lodash';

export const StepperContext = createContext();

export const styles = (theme) => ({
  colorPrimary: {
    color: theme.palette.primary.main,
  },

  colorSecondary: {
    color: theme.palette.secondary.main,
  },

  colorInfo: {
    color: theme.palette.info.main,
  },

  colorSuccess: {
    color: theme.palette.success.main,
  },

  colorWarning: {
    color: theme.palette.warning.main,
  },

  colorError: {
    color: theme.palette.error.main,
  },
});

const Stepper = memo(function Stepper(props) {
  const { children, color, className, classes: classesProp, ...rest } = props;

  const contextValue = useMemo(() => {
    return {
      color,
    };
  }, [color]);

  const {
    colorPrimary: _,
    colorSecondary: __,
    colorInfo: ___,
    colorSuccess: ____,
    colorWarning: _____,
    colorError: ______,
    ...classes
  } = classesProp;

  return (
    <StepperContext.Provider value={contextValue}>
      <MuiStepper
        {...rest}
        className={clsx(className, classesProp[`color${capitalize(color)}`])}
        classes={classes}
      >
        {children}
      </MuiStepper>
    </StepperContext.Provider>
  );
});

Stepper.propTypes = {
  ...MuiStepper.propTypes,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withStyles(styles, { name: 'Stepper' })(Stepper);
